"use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
exports.__esModule = true;
exports.default = void 0;
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var clipboardAvailable;
var Clipboard = /*#__PURE__*/ function() {
    function Clipboard() {
        _class_call_check(this, Clipboard);
    }
    _create_class(Clipboard, null, [
        {
            key: "isAvailable",
            value: function isAvailable() {
                if (clipboardAvailable === undefined) {
                    clipboardAvailable = typeof document.queryCommandSupported === "function" && document.queryCommandSupported("copy");
                }
                return clipboardAvailable;
            }
        },
        {
            key: "getString",
            value: function getString() {
                return Promise.resolve("");
            }
        },
        {
            key: "setString",
            value: function setString(text) {
                var success = false;
                var body = document.body;
                if (body) {
                    // add the text to a hidden node
                    var node = document.createElement("span");
                    node.textContent = text;
                    node.style.opacity = "0";
                    node.style.position = "absolute";
                    node.style.whiteSpace = "pre-wrap";
                    node.style.userSelect = "auto";
                    body.appendChild(node);
                    // select the text
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    var range = document.createRange();
                    range.selectNodeContents(node);
                    selection.addRange(range);
                    // attempt to copy
                    try {
                        document.execCommand("copy");
                        success = true;
                    } catch (e) {}
                    // remove selection and node
                    selection.removeAllRanges();
                    body.removeChild(node);
                }
                return success;
            }
        }
    ]);
    return Clipboard;
}();
exports.default = Clipboard;
module.exports = exports.default;
